var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundSpeakerOff = function SvgSoundSpeakerOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1.2a.8.8 0 0 1 1.3.7v20.8a.8.8 0 0 1-1.3.6L5.3 16H1.6C.7 16 0 15.3 0 14.5V8c0-1 .7-1.6 1.6-1.6h3.7zm4.8 7.6 2.3 2.3 2.2-2.2a.7.7 0 0 1 1 1L21.2 11l2 2a.7.7 0 0 1-.8 1.1h-.1l-2-2.1-2.3 2.2a.7.7 0 0 1-1-1l2.2-2.2L17 8.8a.7.7 0 0 1 .9-1z",
    fillRule: "evenodd"
  })));
};
export default SvgSoundSpeakerOff;